import { listLabFormulas, listBatches } from './labData';
import { listInvoices } from './invoices';
import { listProducts } from './products';
import { listPurchaseOrders } from './purchaseOrders';

/* What a task can point at, and what to do about it.
 *
 * This is the change that makes To-Do part of the dashboard rather than a
 * list beside it: "Make Moonflower Soaps" is a production job, and it should
 * be able to start one.
 *
 * Each type knows how to list its records, how to label one, where it lives,
 * and what the contextual action on the task should say. Adding a linkable
 * section means adding one entry here, not touching the drawer.
 */
export const LINK_TYPES = {
  formula: {
    label: 'Formula',
    list: async () => (await listLabFormulas()).map((f) => ({ id: f.id, label: f.name })),
    to: (id) => `/lab/formulas/${id}`,
    // Straight into the batch wizard, pre-filled — the whole point of
    // linking a task to a formula.
    action: { label: 'Make a batch', to: (id) => `/production?make=${id}` },
  },
  batch: {
    label: 'Batch',
    list: async () =>
      (await listBatches()).map((b) => ({
        id: b.id,
        label: `${b.batch_code || 'Batch'} · ${b.formula?.family?.name || ''}`.trim(),
      })),
    to: (id) => `/production/batches/${id}`,
    action: { label: 'Open batch sheet', to: (id) => `/production/batches/${id}` },
  },
  invoice: {
    label: 'Invoice',
    list: async () =>
      (await listInvoices()).map((i) => ({
        id: i.id,
        label: `${i.invoice_number} · ${i.bill_to_name}`,
      })),
    to: (id) => `/invoices/${id}`,
    action: { label: 'View invoice', to: (id) => `/invoices/${id}` },
  },
  supplier_order: {
    label: 'Order',
    list: async () =>
      (await listPurchaseOrders()).map((o) => ({
        id: o.id,
        label: `${o.po_number} · ${o.vendor?.name || ''}`.trim(),
      })),
    to: () => '/suppliers',
    action: { label: 'View order', to: () => '/suppliers' },
  },
  product: {
    label: 'Product',
    list: async () => (await listProducts()).map((p) => ({ id: p.id, label: p.name })),
    to: () => '/products',
    action: { label: 'View product', to: () => '/products' },
  },
};

export const LINK_TYPE_KEYS = Object.keys(LINK_TYPES);

export function linkTypeLabel(type) {
  return LINK_TYPES[type]?.label || null;
}
